import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function isCalendarReactEnabled(): boolean {
    let userOptions = getUserConfiguration().UserOptions;
    if (userOptions?.ReactOptinSettings) {
        return userOptions.ReactOptinSettings.CalendarEnabled || false;
    } else {
        return false;
    }
}
